import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleSelectingPromoType } from '../../../store/slices/promoSelectModeSlice';
import pluse_promo from '../../../assets/card/pluse_promo.png';
import './button.css'

export default function NewPromoButton({text}) {
    const dispatch = useDispatch();
    const isSelecting = useSelector((state) => state.promoSelectMode.isSelectingPromoType);

    const handleClick = () => {
        dispatch(toggleSelectingPromoType());
    };

    return (
        <div 
            className={'flex flex-row items-center p-0 m-0 shine-effect cursor-pointer'}
            onClick={handleClick}
        >
            <div
                className={`flex flex-row items-center justify-center text-[11px] gap-[11px] w-[155px] h-[20px] border rounded-[5px] transition-all duration-300 ${
                    isSelecting 
                        ? 'border-[#4CAF50] bg-[#1a2e1a] text-[#4CAF50]' 
                        : 'border-[#FFC813] bg-[#252323] text-[#FFC813]'
                }`}
            >
                <span>{isSelecting ? 'select promo type ↓' : text}</span> 
                {!isSelecting && <img width={13} height={13} src={pluse_promo}/>}
            </div>
        </div>
    );
}
